import { addToRootSaga } from 'store';
import { changeUserAndProjectAPI } from 'api/BossErrorAPI';
import { call, put, takeLatest } from 'redux-saga/effects';
import { addNegativeToast } from 'modules/toastContainer';
import * as actionTypes from './actionTypes';

export function* changeUserAndProject({ requestData, callback }) {
  try {
    yield call(changeUserAndProjectAPI, requestData);
    callback();
  } catch (error) {
    const message = `Something went wrong. Please try again`;
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([takeLatest(actionTypes.CHANGE_USER_AND_PROJECT, changeUserAndProject)]);
